<template>
  <section>
    <v-container>
      <v-layout row>
        <v-flex>
          <v-stepper non-linear  v-model="workloadStep">
            <v-stepper-header>
              <v-stepper-step
                editable
                step="1">Step 1 </v-stepper-step>
              <v-divider/>
              <v-stepper-step
                :editable="newWorkload.oppproject.Q7 !== 'Y'"
                step="2">Step 2</v-stepper-step>
              <v-divider/>
              <v-stepper-step
                editable
                step="3">Step 3</v-stepper-step>
              <v-divider/>
              <v-stepper-step
                editable
                step="4">Discount Update</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card class="mb-12">
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md8>
                      <label>
                        Project / Workload Title
                      </label>
                      <v-text-field
                        :disabled="!isRecordView"
                        v-model="newWorkload.oppproject.Workload_Title">
                        <v-tooltip
                          slot="append"
                          left>
                          <v-icon
                            slot="activator"
                            color="primary"
                            dark>info</v-icon>
                          <span>Use a short phrase to describe theworkload, i.e. Legacy DC Migration,Virtual Desktop Migration or Hybrid Cloud Transformation</span>
                        </v-tooltip>
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md8>
                      <label>Enter the DXC campaign name if applicable</label>
                      <v-text-field
                        :disabled="!isRecordView"
                        v-model="newWorkload.oppproject.Campaign_Name"
                        solo
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      v-if="newWorkload.oppproject.Is_Glacier == 'Y' || newWorkload.oppproject.Is_Glacier == 'N'"
                      xs12
                      sm12
                      md8>
                      <v-checkbox
                        :disabled="!isRecordView"
                        class="d-inline-flex"
                        v-model="newWorkload.oppproject.Is_Glacier"
                        color="orange"
                        true-value="Y"
                        false-value="N"
                        @change="toggleIsGlacier" />
                      <label style="position:relative; bottom: 3px">Check the box if your OPX has been DXC Regionally vetted as the Glacier Campaign</label>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="newWorkload.oppproject.Campaign_Name.includes('Glacier')" class="sow-field">
                    <v-flex
                      md8
                      class="pt-2">
                      <label>Glacier SOW Qty <span class="required">*</span></label>
                      <p>If your Glacier OPX is only for Assess Phase, please select zero in the SOW drop down.</p>
                      <p>If the SOW quantity changes in the future, please notify <a href="mailto:AWS-Oppreg@cloud.dxc.com">AWS-Oppreg@cloud.dxc.com</a> and the DXC Oppreg admin team will update the record.</p>
                    </v-flex>
                    <v-flex md2 >
                      <v-select
                        v-validate="{ required: true }"
                        :disabled="!isRecordView"
                        :items="['0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10']"
                        v-model="newWorkload.oppproject.Scope_of_Work"
                        :error-messages="errors.collect('Scope_of_Work')"
                        data-vv-validate-on="blur"
                        placeholder="Select an option"
                        data-vv-name="Scope_of_Work"
                        solo
                        attach
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                      sm12 
                      md8
                    >
                      <label>Select from the drop down list the DXC business segment that best describes the overall OPX</label>
                      <v-select
                        v-model="newWorkload.oppproject.Solution_Business_Segment"
                        :items="solutionBusinessSegments"
                        label="Please select one"
                        required
                        solo
                        attach
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex md12>
                      <label class="font-weight-bold">Project Description</label>
                      <hr class="my-2">
                      <label>1. What are the client’s pain points and business objectives? What is the plan for AWS in support of the client’s desired outcomes? <span class="required">*</span></label>
                      <v-textarea
                        v-validate="{ required: true }"
                        v-model.lazy="newWorkload.oppproject.Q1"
                        :disabled="!isRecordView"
                        :error-messages="errors.collect('projectDesc1')"
                        data-vv-name="projectDesc1"
                        data-vv-validate-on="blur"
                        solo
                        rows="3"
                      />
                    </v-flex>
                    <v-flex md12>
                      <label>2. What is the role of DXC in this project? Which Software applications  and/or tools will support the solution? <span class="required">*</span></label>
                      <v-textarea
                        v-validate="{ required: true }"
                        v-model.lazy="newWorkload.oppproject.Q2"
                        :disabled="!isRecordView"
                        :error-messages="errors.collect('projectDesc2')"
                        data-vv-name="projectDesc2"
                        data-vv-validate-on="blur"
                        solo
                        rows="3"
                      />
                    </v-flex>
                    <v-flex md12>
                      <label>3. What specific client department or subsidiary is DXC working with? <span class="required">*</span></label>
                      <v-textarea
                        v-validate="{ required: true }"
                        v-model.lazy="newWorkload.oppproject.Q3"
                        :disabled="!isRecordView"
                        :error-messages="errors.collect('projectDesc3')"
                        data-vv-name="projectDesc3"
                        data-vv-validate-on="blur"
                        solo
                        rows="3"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                      md6
                      class="pt-2">
                      <label>4. What is the monthly estimated AWS spend for this opportunity (in USD)<span class="required">*</span></label>
                      <p>If you are unsure, Feel free to use these estimates.
                        <ul>
                          <li>Migrations or SaaS $15,000 per month (or greater)</li>
                          <li>SAP Migration $20,000 per month (or greater)</li>
                          <li>Managed Services $20,000 per month (or greater)</li>
                        </ul>
                      </p>
                    </v-flex>
                    <v-flex md6 >
                      <v-text-field
                        v-validate="'required|decimal:2'"
                        v-model="newWorkload.oppproject.Q4"
                        :disabled="!isRecordView"
                        :error-messages="errors.collect('Projected_Monthly_Spend')"
                        type="number"
                        prepend-icon="attach_money"
                        class="padding-left-15"
                        data-vv-name="Projected_Monthly_Spend"
                        data-vv-validate-on="blur"
                        solo
                      />
                    </v-flex>
                  </v-layout>
                  <div class="mt-2 px-2 py-1 black">
                    <label class="font-weight-bold white--text">Additional Questions</label>
                  </div>
                  <v-layout
                    row
                    wrap
                    align-center>
                    <v-flex
                      md10
                      pt-2>
                      <label>5. Is the client categorized in the Public Sector industry segment?
                        <span class="required">*</span>
                      </label>
                    </v-flex>
                    <v-flex
                      md2>
                      <v-layout 
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.oppproject.Q5">
                            <v-btn
                              id="q1"
                              :class="{ 'v-btn--active': newWorkload.oppproject.Q5 === 'Y' }"
                              :disabled="!isRecordView"
                              value="Y"
                              class="black--text btn--qa">Yes</v-btn>
                            <v-btn
                              :class="{ 'v-btn--active': newWorkload.oppproject.Q5 === 'N' }"
                              :disabled="!isRecordView"
                              value="N"
                              class="black--text btn--qa">No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    align-center>
                    <v-flex
                      md10
                      pt-2>
                      <label>6. If the client is in the Public Sector industry, will DXC be providing Advisory Services that encompass a Cloud Service provider selection or procurement?
                        <span class="required">*</span>
                      </label>
                    </v-flex>
                    <v-flex
                      md2>
                      <v-layout 
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.oppproject.Q6">
                            <v-btn
                              id="q1"
                              :class="{ 'v-btn--active': newWorkload.oppproject.Q6 === 'Y' }"
                              :disabled="!isRecordView"
                              value="Y"
                              class="black--text btn--qa">Yes</v-btn>
                            <v-btn
                              :class="{ 'v-btn--active': newWorkload.oppproject.Q6 === 'N' }"
                              :disabled="!isRecordView"
                              value="N"
                              class="black--text btn--qa">No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    align-center>
                    <v-flex
                      md10
                      pt-2>
                      <label class="font-weight-bold">7.  In this opportunity, will the client's current non-DXC AWS account be transferring to a DXC owned Master payer?.
                        <span class="required">*</span>
                      </label>
                      <p class="pr-5">If YES, then send an email to the DXC Account Onboarding team at <a href="mailto:aws-account-onboarding@cloud.dxc.com">aws-account-onboarding@cloud.dxc.com</a> regarding “Consent to Assignment”.  The team will assist with account transfer pricing and requirement guidance for the AWS Consent To Assignment (CTA) process.<br /> You must also tag your DXC SF opportunity in the product detail Technology Provider field with “Amazon Web Services”. Once your SF tag is verified by the DXC Oppreg team, your registration will be submitted to AWS.</p>
                    </v-flex>
                    <v-flex
                      md2>
                      <v-layout
                        column
                        align-end>
                        <v-flex>
                          <v-btn-toggle v-model="newWorkload.oppproject.Q7" @change="determineTransferWorkloadType">
                            <v-btn
                              id="q1"
                              :disabled="!isRecordView"
                              :class="{ 'v-btn--active': newWorkload.oppproject.Q7 === 'Y' }"
                              value="Y"
                              class="black--text btn--qa"
                            >Yes</v-btn>
                            <v-btn
                              :disabled="!isRecordView"
                              :class="{ 'v-btn--active': newWorkload.oppproject.Q7 === 'N' }"
                              value="N"
                              class="black--text btn--qa"
                            >No</v-btn>
                          </v-btn-toggle>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex class="text-md-center">
                      <v-btn
                        v-if="newWorkload.oppproject.Q7 == 'Y'"
                        color="success"
                        @click="workloadStep = 3; $store.commit('admin/oppregAdmin/clearDiscountTier2Answers')">
                        CONTINUE
                      </v-btn>
                      <v-btn
                        v-if="newWorkload.oppproject.Q7 == 'N'"
                        color="success"
                        @click="workloadStep = 2">
                        CONTINUE
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  
                  <v-btn v-if="newWorkload.oppproject.Q8 || newWorkload.oppproject.Q9 || newWorkload.oppproject.Q10" class="btn--qa red--text" @click="viewOldPricingQA = !viewOldPricingQA">
                    <span v-if="!viewOldPricingQA">
                      If applicable, Click Here to View Old Pricing Tier Questions and Answers
                    </span>
                    <span v-else>
                      Go Back
                    </span>
                  </v-btn>

                  <div v-if="viewOldPricingQA" class="old-pricing-qa pb-3 border-2">
                    <div class="pricing-tier-overview-container">
                      <div class="my-2 px-2 py-1 black">
                        <label class="font-weight-bold white--text">Pricing Tiers Overview</label>
                      </div>
                      <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
                      <ul>
                        <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
                        <li>Private Pricing Agreement (PPA) – 23% discount for qualified workloads.</li>
                        <li>View the OppReg guide download for pricing tier details. </li>
                      </ul>
                    </div>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex md12>
                        <div class="my-2 px-2 py-1 black">
                          <label class="font-weight-bold white--text">Pricing Tier Qualification</label>
                        </div>
                        <div class="my-2">
                          <label>Answer the following questions to determine the applicable Pricing Tier – final tier approval will be provided by Galaxy email to you upon AWS approval. </label>
                        </div>
                        <v-layout align-center>
                          <v-flex md9>
                            <label class="mr-3 font-weight-bold">8. Will the client require access to DXC’s AWS login credentials, the AWS Management Console or AWS resources, e.g. S3 storage or EC2 instances? If YES, then workload qualifies for SPP and there is no need for questions 9 and 10.  <span class="required">*</span></label>
                          </v-flex>
                          <v-flex md3 class="text-md-center">
                            <v-btn-toggle v-model="newWorkload.oppproject.Q8">
                              <v-btn
                                :class="{ 'v-btn--active': newWorkload.oppproject.Q8 === 'Y' }"
                                :disabled="!isRecordView"
                                value="Y"
                                class="black--text btn--qa">Yes</v-btn>
                              <v-btn
                                :class="{ 'v-btn--active': newWorkload.oppproject.Q8 === 'N' }"
                                :disabled="!isRecordView"
                                value="N"
                                class="black--text btn--qa">No</v-btn>
                            </v-btn-toggle>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center v-if="newWorkload.oppproject.Q8 == 'Y'">
                          <v-flex md9>
                            <div class="px-2 py-1 black text-md-right">
                              <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                            </div>
                          </v-flex>
                          <v-flex md3>
                            <div class="d-flex align-center">
                              <div class="text-md-center black px-2 py-1">
                                <span class="font-weight-bold white--text">SPP Pricing Tier</span>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center style="position:relative">
                          <div v-if="newWorkload.oppproject.Q8 == 'Y' || !newWorkload.oppproject.Q8" class="disabled-section"></div>
                          <v-flex md9>
                            <label class="mr-3 font-weight-bold">9. Will the AWS resources be used for a SaaS or PaaS solution delivered by DXC? If YES, then workload qualifies for PPA and there is no need for question 10.<span v-if="newWorkload.oppproject.Q7 == 'N'" class="required">*</span></label>
                          </v-flex>
                          <v-flex md3 class="text-md-center">
                            <v-btn-toggle v-model="newWorkload.oppproject.Q9" :disabled="!isRecordView">
                              <v-btn
                                :class="{ 'v-btn--active': newWorkload.oppproject.Q9 === 'Y' }"
                                :disabled="!isRecordView"
                                value="Y"
                                class="black--text btn--qa">Yes</v-btn>
                              <v-btn
                                :class="{ 'v-btn--active': newWorkload.oppproject.Q9 === 'N' }"
                                :disabled="!isRecordView"
                                value="N"
                                class="black--text btn--qa">No</v-btn>
                            </v-btn-toggle>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center style="position:relative" v-if="newWorkload.oppproject.Q9 == 'Y'">
                          <div v-if="newWorkload.oppproject.Q8 == 'Y' || !newWorkload.oppproject.Q8" class="disabled-section"></div>
                          <v-flex md9>
                            <div class="px-2 py-1 black text-md-right">
                              <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                            </div>
                          </v-flex>
                          <v-flex md3>
                            <div class="d-flex align-center">
                              <div class="text-md-center black px-2 py-1">
                                <span class="font-weight-bold white--text">PPA Pricing Tier</span>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center style="position:relative">
                          <div v-if="newWorkload.oppproject.Q8 == 'Y' || !newWorkload.oppproject.Q8  || newWorkload.oppproject.Q9 == 'Y' || !newWorkload.oppproject.Q9" class="disabled-section"></div>
                          <v-flex md9>
                            <label class="mr-3 font-weight-bold">10. For existing non-AWS workloads, has DXC been providing managed services for the workload(s) since September 1, 2018? If YES, then workload qualifies for PPA.<span v-if="newWorkload.oppproject.Q7 == 'N' && newWorkload.oppproject.Q8 == 'N'" class="required">*</span></label>
                          </v-flex>
                          <v-flex md3 class="text-md-center">
                            <v-btn-toggle v-model="newWorkload.oppproject.Q10" :disabled="!isRecordView">
                              <v-btn
                                :class="{ 'v-btn--active': newWorkload.oppproject.Q10 === 'Y' }"
                                :disabled="!isRecordView"
                                value="Y"
                                class="black--text btn--qa">Yes</v-btn>
                              <v-btn
                                :class="{ 'v-btn--active': newWorkload.oppproject.Q10 === 'N' }"
                                :disabled="!isRecordView"
                                value="N"
                                class="black--text btn--qa">No</v-btn>
                            </v-btn-toggle>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center style="position:relative" v-if="newWorkload.oppproject.Q10">
                          <div v-if="newWorkload.oppproject.Q8 == 'Y' || !newWorkload.oppproject.Q8  || newWorkload.oppproject.Q9 == 'Y' || !newWorkload.oppproject.Q9" class="disabled-section"></div>
                          <v-flex md9>
                            <div class="px-2 py-1 black text-md-right">
                              <label class="font-weight-bold white--text">Your response qualifies the workload for:</label>
                            </div>
                          </v-flex>
                          <v-flex md3>
                            <div class="d-flex align-center black px-2 py-1">
                              <div class="font-weight-bold text-md-center white--text" v-if="newWorkload.oppproject.Q10 == 'Y'">
                                PPA Pricing Tier
                              </div>
                              <div class="font-weight-bold text-md-center white--text" v-if="newWorkload.oppproject.Q10 == 'N'">
                                SPP Pricing Tier
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>

                  <formAdminOppregWorkloadStep2New v-else @continue="workloadStep = 3"/>                  
                  <v-layout>
                    <v-flex class="text-md-center">
                      <v-btn color="success" @click="workloadStep = 1">GO BACK</v-btn>
                      <v-btn
                        color="success"
                        @click="workloadStep = 3">
                        CONTINUE
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card class="mb-12">
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      sm12
                      md12
                      xl12>
                      <span style="font-weight: bold">
                        Contact Information
                      </span>
                      <v-layout
                        row
                        wrap>
                        <v-flex md6>
                          <v-text-field
                            :disabled="!isRecordView"
                            v-model="workload.contact.Contact_First_Name"
                            placeholder="First Name"
                            readonly
                            solo
                          />
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            :disabled="!isRecordView"
                            v-model="workload.contact.Contact_Last_Name"
                            placeholder="Last Name"
                            solo
                            readonly
                            required
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout
                        row
                        wrap>
                        <v-flex md6>
                          <v-text-field
                            :disabled="!isRecordView"
                            v-model="workload.contact.Contact_Email"
                            placeholder="Contact email"
                            solo
                            readonly
                          />
                        </v-flex>
                        <v-flex md6>
                          <v-text-field
                            :disabled="!isRecordView"
                            v-model="workload.contact.Contact_Phone"
                            placeholder="Contact phone"
                            solo
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex md12 class="mt-2">
                      <p>Download the Opportunity Registration guide, available in the left column Galaxy menu, to understand the timeline graph on the steps towards AWS acceptance and notifications after you submit in Galaxy.  See the guide for how to view any DXC registration request and registration status. </p>
                      <hr />
                      <p class="mt-2">Again, if the client owned AWS account will be transferred to a DXC Master Payer, then after you click "submit", please email the DXC team at AWS Account <a href="mailto:Onboarding@cloud.dxc.com">Onboarding@cloud.dxc.com</a> for further assistance on pricing and account transfer to DCX process (CTA).</p>
                      <hr />
                      <p class="mt-2"> For any additional support, please contact the Galaxy team at <a href="mailto:GuardiansoftheGalaxy@dxc.com">GuardiansoftheGalaxy@dxc.com</a></p>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="4">
                <formAdminUpdateDiscountStep/>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
      <v-layout
        row>
        <v-flex>
          <h3 mt-1>
            Current Workload Type:
            <span>{{ newWorkload.oppproject.Workload_type }}</span>
          </h3>
        </v-flex>
        <v-flex>
          <h3 mt-1>
            Workload Type:
            <span>{{ newWorkload.workloadType }}</span>
          </h3>
        </v-flex>
        <v-flex style="text-align: right">
          <Can
            i="write"
            a="oppreg-admin">
            <v-btn
              :loading="workload.submitting"
              class="opp-btn"
              color="warning"
              @click="onUpdateQuestionnaire">Update Questionnaire</v-btn>
          </Can>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { checkActionPermission } from '@/utils/helper'

export default {
  data () {
    return {
      sameAsLoggedInUser: false,
      awsServicesRegions: [
        {
          text: 'US East (N.Virginia)',
          value: 'US East (N.Virginia)',
          selected: false
        },
        {
          text: 'Asia Pacific (Mumbai)',
          value: 'Asia Pacific (Mumbai)',
          selected: false
        },
        { text: 'US East (Ohio)', value: 'US East (Ohio)', selected: false },
        {
          text: 'Asia Pacific (Osaka)',
          value: 'Asia Pacific (Osaka)',
          selected: false
        },
        {
          text: 'US West (N.California)',
          value: 'US West (N.California)',
          selected: false
        },
        {
          text: 'Asia Pacific (Seoul)',
          value: 'Asia Pacific (Seoul)',
          selected: false
        },
        {
          text: 'US West (Oregon)',
          value: 'US West (Oregon)',
          selected: false
        },
        {
          text: 'Asia Pacific (Singapore)',
          value: 'Asia Pacific (Singapore)',
          selected: false
        },
        {
          text: 'Canada (Central)',
          value: 'Canada (Central)',
          selected: false
        },
        {
          text: 'Asia Pacific (Sydney)',
          value: 'Asia Pacific (Sydney)',
          selected: false
        },
        { text: 'EU (Frankfurt)', value: 'EU (Frankfurt)', selected: false },
        {
          text: 'Asia Pacific (Tokyo)',
          value: 'Asia Pacific (Tokyo)',
          selected: false
        },
        { text: 'EU (Ireland)', value: 'EU (Ireland)', selected: false },
        {
          text: 'South America (Sao Paolo)',
          value: 'South America (Sao Paolo)',
          selected: false
        },
        { text: 'EU (Paris)', value: 'EU (Paris)', selected: false },
        { text: 'GovCloud (US)', value: 'GovCloud (US)', selected: false },
        { text: 'UK (London)', value: 'UK (London)', selected: false }
      ],
      awsServices: [
        {
          text: 'Alexa Web Information Service',
          value: 'Alexa Web Information Service',
          selected: false
        },
        {
          text: 'Amazon Registrar',
          value: 'Amazon Registrar',
          selected: false
        },
        {
          text: 'Aws Marketplace Beta Services',
          value: 'Aws Marketplace Beta Services',
          selected: false
        },
        {
          text: 'Amazon S3 Glacier Deep Archive',
          value: 'Amazon S3 Glacier Deep Archive',
          selected: false
        },
        {
          text: 'Deep Archive',
          value: 'Deep Archive',
          selected: false
        },
         {
          text: 'AWS IQ',
          value: 'AWS IQ',
          selected: false
        },
        { text: 'Not Applicable', value: 'Not Applicable', selected: false }
      ],
      solutionBusinessSegments: [
        'DXC Insurance Software Business (ISB)',
        'DXC Consulting & Engineering Services (CES)',
        'DXC Global Infrastructure Services (GIS)',
      ],
      attestedDateMenu: false,
      workloadStep: 1,
      viewOldPricingQA: false
    }
  },
  computed: {
    ...mapState('admin/oppregAdmin', ['workload', 'newWorkload']),
    opportunityForGainwell () {
      return !this.workload.opportunity.Opportunity_Id.indexOf('DXCGNW')
    },
    computedAwsServices: {
      get: function () {
        // TODO hardcode for now, later get value from state
        // let workloadAwsServices = ['Alexa Web Information Service', 'Amazon S3 Glacier Deep Archive', 'Not Applicable']
        let workloadAwsServices = JSON.parse(this.newWorkload.wlqa.WL_Q7A)
        let awsServices = this.awsServices.map((service, index) => {
          let serviceFound = workloadAwsServices.some(
            value => value === service.value
          )
          if (serviceFound) {
            return { ...service, selected: true }
          } else {
            return { ...service, selected: false }
          }
        })
        return awsServices
      }
    },
    attestedDate: {
      get () {
        return window.moment(this.newWorkload.oppproject.Attested_By_Date).isValid()
          ? this.newWorkload.oppproject.Attested_By_Date
          : null
      },
      set (date) {
        this.newWorkload.oppproject.Attested_By_Date = date
      }
    },
    workloadType () {
      console.log('workload type computed')
      return this.newWorkload.workloadType
    },
    isRecordView () {
      return checkActionPermission('write', 'oppreg-admin')
    }
  },
  methods: {
    ...mapActions({
      updateQuestionnaire: 'admin/oppregAdmin/updateQuestionnaire'
    }),
    onUpdateQuestionnaire: function () {
      let questionnaireUpdates = {
        answers: this.newWorkload.oppproject, 
        id: this.newWorkload.oppproject.Registration_Id, 
        type: this.newWorkload.workloadType ? this.newWorkload.workloadType : this.newWorkload.oppproject.Workload_type
      }
      this.updateQuestionnaire(questionnaireUpdates)
    },
    determineTransferWorkloadType () {
      let workloadType
      if (this.newWorkload.oppproject.Q7 === 'Y') {
        workloadType = 'Transfer'
      } else if (this.newWorkload.oppproject.Q7 === 'N') {
        workloadType = ''
      }
      this.$store.commit('admin/oppregAdmin/setWorkloadType', workloadType)
    },
    toggleIsGlacier (val) {
      this.newWorkload.oppproject.Campaign_Name = val == 'Y' ? 'Glacier' : ''
    },
  }
}
</script>
<style lang="scss" scoped>
.disable-events {
  pointer-events: none;
}

.v-btn-toggle {
  margin: 10px 0;
}
.v-btn-toggle .v-btn {
  padding: 15px 25px;
  opacity: 0.7px;
}
.btn--qa {
  font-weight: bold !important;
}
.v-btn--active:before,
.v-btn:focus:before,
.v-btn:hover:before {
  background-color: grey;
}
.v-btn-toggle .v-btn.v-btn--active{
    background-color: #ff9900 !important;
  }

.disabled-section {
  background: #f5f5f5;
  width: 100%;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 99;
  height: 100%;
  opacity: 0.7;
}
.sow-field {
  margin-bottom: 40px;
}
</style>
